import React, { useState, useEffect } from 'react'
import './BusSat.scss'
import useTeam from './common/hooks/useTeam'
import Team from "./Team/Team"
import Bus from "./Bus/Bus"
import Modal from "../../partials/Modal/SimpleModal/SimpleModal"
import Questions from './Questions/Questions'
import RevisedAndContinue from './ReviseAndContinue'

/**
 * Shared Components
 */
 import InteractionContainer from "../../partials/InteractionContainer/InteractionContainer";
import Kpis, { kpiUpdate } from "../../partials/Kpis"
import Footer from "../../partials/Footer"
import Button from '../../partials/Button'
import HTMLContent from "../../partials/HTMLContent"
import HiddenPanel from "../../partials/HiddenPanel"
import DecisionCircles, {deployDecisions, isItDeployed} from '../../partials/DecisionCircles'
import HorizontalRange from '../../partials/UI/Range/Horizontal'
import TeamFeedback from './Team/TeamFeedback/TeamFeedback'
import ButtonsHolder from '../../partials/Button/ButtonsHolder'
import Header from '../../partials/Header';
import Scroll from '../../partials/Scroll/Scroll'

const BusSat =  ({ breadcrumbs, data, onComplete, goBackToPreviousSegment }, props) => {

    const [kpis, setKpis ] = useState(() => {
        return data.kpis_initial_values || {}
    })
    const markers = data.markers || []
    const { members, currentSpeech } = useTeam(data.team || {})
    const { outcomes } = data || {}

    const [showIntro, setShowIntro] = useState(false)
    const [ choicesCompleted , setChoicesCompleted ] = useState(false)
    const [showFormulas, setShowFormulas] = useState()

    const [ showDialog, setShowDialog ] = useState(false)
    const [ dialogData, setDialogData ] = useState({})

    const [ selectedOptions, setSelectedOptions ] = useState({})
    const [ choices, setChoices] = useState([])
    const [paintParts, setPaintParts] = useState([])
    const [selectedRootCategory, setSelectedRootCategory] = useState()
    const [ currentState, setCurrentState ] = useState('decisionTree')


    const [categoriesData, setCategoriesData] = useState()
    const [instructionsFeedback, setInstructionsFeedback] = useState()
    const [memberFeedback, setMemberFeedback] = useState()


    useEffect(()=> {
        if(!categoriesData){
            setShowIntro(true)
            setCategoriesData(data.categories)
        }
        setInstructionsFeedback(data.intro)
        
    },[])
    useEffect( () => {

    }, [selectedOptions,selectedRootCategory, categoriesData])

    useEffect( () => {
        if(categoriesData && paintParts.length === categoriesData.length) {
            setChoicesCompleted(true)
        }
    },[paintParts])


    /**
     * Handles Deploy Button Actions
     * @param {*} selection 
     */
    const handleDeploy = (selection) => {

        const deployedDecisions = deployDecisions(selectedRootCategory, selection)
        
        const deployedCategory = {
            ...selectedRootCategory,
            choosed:true,
            done: isItDeployed(deployedDecisions),
            decisions: deployedDecisions
        }
        
        const updatedCategories = categoriesData.map((catItem) => {
            return catItem.id === deployedCategory.id ? deployedCategory : catItem
        })
        
        setSelectedRootCategory(deployedCategory)
        setCategoriesData(updatedCategories)
        setKpis(kpiUpdate(kpis, selection.kpis))
        
        setChoicesCompleted(
            isItDeployed(updatedCategories, true)
        )

        setShowDialog(false)

    }

    const handleCategorySelection = (categoryIndex) => {
        setSelectedRootCategory(categoriesData[categoryIndex])
    }
    const handleCategoryCallback = (result) => {
        setShowDialog(true)
        setDialogData(result.answer)
    }

    const handleFormulas =()=>{
        setShowFormulas(showFormulas ? false : true)
    }

    const handleDeployRangeValues = (e) => {
        setDialogData({
            ...dialogData,
            deploy: {
                ...dialogData.deploy,
                value: e.target.value
            }
        })
    }

    const handleDeployModalClose = (e) => {
        setShowDialog(false)
    }

    const handleTeamCallback = (member) => {
        setMemberFeedback(member)
    }
    const handleBackButton = () =>{

        if(currentState === 'decisionTree') goBackToPreviousSegment()
        if(currentState === 'revise') setCurrentState('decisionTree')
        if(currentState === 'questions') setCurrentState('revise')

    }
    
    return (
        <InteractionContainer withFrame={true} breadcrumbs={breadcrumbs}>
            <div className="bus-sat">
                <Header 
                    title='Payload' 
                    intro={instructionsFeedback} 
                    button={()=><Button 
                        icon="formulas"
                        text="Check Formulas" 
                        className='primary small' 
                        onClick={handleFormulas}
                        />
                        }
                    backButtonHandler={handleBackButton} 
                />
                {currentState === 'decisionTree' &&
                    <>
                        <div className="bus-sat-body">
                            <div className="left-panel">
                                { categoriesData && 
                                    
                                    <DecisionCircles 
                                        categories={categoriesData} 
                                        onSelectHandle={handleCategorySelection}
                                        callback={handleCategoryCallback} />
                                }
                            </div>
                            <div className="right-panel">
                                
                                
                                <div className="simulation-block">  
                                    <Bus elements={paintParts} choices={choices}/>
                                    <Button 
                                        text="Run Simulation" 
                                        disabled={!choicesCompleted}
                                        variant="wide" 
                                        onClick={() => setCurrentState('revise')} />

                                </div>                      
                            </div>
                        </div>
                    </>
                }
                {currentState === 'revise' && 
                    <RevisedAndContinue
                        data={data.simulation}
                        onRevise={() => setCurrentState('decisionTree')} 
                        onContinue={() => setCurrentState('questions')}
                    />
                }
                { currentState === 'questions' &&
                    <Questions data={data} onComplete={ () => {
                        if (onComplete) {
                        onComplete(paintParts)
                        }
                    } } />
                }
                

                { showFormulas && 
                    <Modal 
                        size="small" 
                        header="Formulas"
                        html={data.formulas}
                        show={true}
                        scroll={false}
                        onClose={ handleFormulas } >
                    </Modal>
                }

                { memberFeedback && 
                    <Modal 
                        size="small" 
                        show={memberFeedback} 
                        onClose={ () => setMemberFeedback() } >

                            <TeamFeedback member={memberFeedback} />
                    </Modal>
                }

                <Modal 
                    show={showDialog}
                    size="small"
                    className='bus-feedback-modal'
                    scroll={false}
                    header={dialogData.name} >   
                    <Scroll>
                        <div className="scrollable-popup" dangerouslySetInnerHTML={{ __html: dialogData.desc }}></div>
                        {/* <HTMLContent html={dialogData.desc} /> */}
                    </Scroll>
                    {dialogData.deploy &&
                        <div className="range-deploy">
                            <HorizontalRange 
                                min={dialogData.deploy.min} 
                                max={dialogData.deploy.max}
                                label={dialogData.deploy.label}
                                value={dialogData.deploy.value} 
                                onChange={handleDeployRangeValues}
                            />
                        </div>
                    }
                        
                    <ButtonsHolder variant="single" orientation="right" >
                        <Button 
                            text={'Deploy'}
                            onClick={() => handleDeploy(dialogData)} 
                        />
                        <Button 
                            text={'Close'}
                            onClick={handleDeployModalClose} 
                        />
                    </ButtonsHolder>

                </Modal>

                {/* This will be used on V2, don't remove it please */}
                {/* <Footer>
                    <Kpis kpis={kpis} markers={markers} />
                </Footer> */}
                {/* <HiddenPanel button="Ask the team" >
                    <Team 
                        members={members}  
                        speak={currentSpeech}
                        callback={handleTeamCallback}    
                    />
                </HiddenPanel> */}
            
            </div>
        </InteractionContainer>
    )

}

export default BusSat
